<script setup>
import { ref, watch, inject } from 'vue';
import { AxiosAPI } from '@/axios';
import { useMainStore } from '../../../stores/index';
import ModalMain from './ModalMain.vue';
import ModalResponsable from './ModalResponsable.vue';
import ModalCopy from './ModalCopy.vue';
import ModalDelete from './ModalDelete.vue';
import TodoListUpdated from './TodoListUpdate.vue';
import moment from 'moment';

const emit = defineEmits(['taskDescription']);

const Store = useMainStore();
const emitter = inject('emitter');

const viewDocument = ref(null);
const modalResponsable = ref(null);
const ModalCopyRef = ref(null);
const ModalDeleteRef = ref(null);
const fileInput = ref(null);

const id = ref(0);
const viewSelect = ref('Resume');
const TaskName = ref('');
const description = ref('');
const location = ref('');
const access_link = ref('');
const hour = ref('');
const situation = ref('');
const priority = ref('');
const responsible = ref({});
const attachments = ref([]);
const CheckList = ref([]);
const editCard = ref(false);
const usersAll = ref([]);
const users = ref([]);
const ModelUser = ref([]);
const Data = ref({});
const formatedDates = ref('');
const editDate = ref('');
const logsAll = ref([]);

const EditNameTask = ref('');
const EditDescriptionTask = ref('');
const Edithour = ref('');
const EditPlace = ref('');
const EditPlaceLink = ref('');
const EditPriority = ref('');
const EditSituation = ref('');
const EditAttachments = ref([]);
const EditTack = ref([]);
const ToRemove = ref([]);
const Editusers = ref([]);

const situationChose = ref([
  { label: 'À iniciar', value: '1' },
  { label: 'Em andamento', value: '2' },
  { label: 'Concluída', value: '3' },
  { label: 'Bloqueado', value: '4' }
]);

const priorityLabels = ref([
  { label: 'Baixa', value: 1 },
  { label: 'Média', value: 2 },
  { label: 'Alta', value: 3 }
]);

watch(ModelUser, (value) => {
  if (!id.value) return;
  users.value = [];
  value.forEach(userId => {
    usersAll.value.forEach(userAll => {
      if (userId === userAll.id) {
        users.value.push(userAll);
      }
    });
  });

  AxiosAPI.put(`/api/tasks/${id.value}`, {
    users: users.value.map(u => u.id)
  }, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Store.accessToken}`
    }
  }).then(() => {
    emit('taskDescription');
  });
});

const formatDate = (value) => {
  moment.locale('pt-br');
  return moment(value).format('dddd, DD [de] MMMM');
};

const formatdateToEdit = (value) => {
  moment.locale('en-us');
  editDate.value = moment(value).format('yyyy-MM-DD');
};

const formatHour = (value) => {
  if (value === '00:00:00' || !value) {
    return 'Não informado';
  } else {
    return moment(value, 'HH:mm:ss').format('HH:mm');
  }
};

const openTask = (value) => {
  const dataUser = [];
  const modelUserList = [];
  id.value = value.id;
  TaskName.value = value.title;
  logsAll.value = value.logs ? [...value.logs].reverse() : [];
  description.value = value.description;
  location.value = value.location;
  access_link.value = value.access_link;
  formatedDates.value = value.date;
  formatdateToEdit(value.date);
  hour.value = value.hour;
  situation.value = value.situation;
  priority.value = value.priority;
  responsible.value = value.responsible || {};
  viewSelect.value = 'Resume';
  attachments.value = value.attachments || [];
  CheckList.value = value.checklists || [];
  Store.EditresponsableTask = value.responsible || {};
  editCard.value = false;

  if (value.users) {
    value.users.forEach(u => {
      dataUser.push(u);
      modelUserList.push(u.id);
    });
  }

  const SlotUsers = [];
  if (Store.users) {
    Store.users.forEach(u => {
      SlotUsers.push({
        ...u,
        value: u.id,
        label: u.name
      });
    });
  }

  usersAll.value = SlotUsers;
  users.value = dataUser;
  ModelUser.value = modelUserList;
  Data.value = value;

  if (viewDocument.value) {
    viewDocument.value.openModal();
  }
};

const RemoveCard = () => {
  if (ModalDeleteRef.value) {
    ModalDeleteRef.value.openModalDelete(id.value);
  }
};

const CopyCard = () => {
  if (ModalCopyRef.value) {
    ModalCopyRef.value.openModalCopy(id.value);
  }
};

const addAttachment = (event) => {
  const files = Array.from(event.target.files);
  const newFiles = files.filter(file =>
    !EditTack.value.some(existingFile => existingFile.name === file.name)
  );

  EditAttachments.value.push(...newFiles.map(file => ({ name: file.name })));
  EditTack.value.push(...newFiles);
};

const removeAttachment = (index) => {
  if (EditTack.value[index] && EditTack.value[index].id) {
    ToRemove.value.push(EditTack.value[index].id);
  }
  EditAttachments.value.splice(index, 1);
  EditTack.value.splice(index, 1);
};

const openFileInput = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
};

const editCardModel = () => {
  editCard.value = true;
  EditNameTask.value = TaskName.value;
  EditDescriptionTask.value = description.value;
  Edithour.value = formatHour(hour.value);
  EditPlace.value = location.value;
  EditPlaceLink.value = access_link.value;
  EditPriority.value = priority.value;
  EditSituation.value = situation.value;
  EditTack.value = [...attachments.value];
  Editusers.value = [...users.value];
};

const editResponsable = () => {
  if (modalResponsable.value) {
    modalResponsable.value.openModalEdit();
  }
};

const EditTask = () => {
  const userIds = Editusers.value.map(u => u.id);
  const formData = new FormData();
  formData.append('_method', 'PUT');
  formData.append('title', EditNameTask.value);
  formData.append('description', EditDescriptionTask.value);
  formData.append('date', editDate.value);
  
  if (Edithour.value === 'Não informado') {
    formData.append('hour', '00:00');
  } else {
    formData.append('hour', Edithour.value);
  }

  formData.append('location', EditPlace.value || '');
  if (EditPlaceLink.value != null) {
    formData.append('access_link', EditPlaceLink.value);
  }
  
  if (typeof EditPriority.value === 'object' && EditPriority.value !== null) {
    formData.append('priority', EditPriority.value.value);
  } else {
    formData.append('priority', EditPriority.value);
  }

  if (typeof EditSituation.value === 'object' && EditSituation.value !== null) {
    formData.append('situation', EditSituation.value.value);
  } else {
    formData.append('situation', EditSituation.value);
  }

  if (Store.EditresponsableTask && Store.EditresponsableTask.id) {
    formData.append('responsible_id', Store.EditresponsableTask.id);
  }

  userIds.forEach(uId => {
    formData.append('users[]', uId);
  });

  if (attachments.value.length >= 1) {
    attachments.value.forEach(att => {
      if (att.id) {
        formData.append('old_attachments[]', att.id);
      }
    });
  }

  EditTack.value.forEach(att => {
    if (!att.id) {
      formData.append('new_attachments[]', att);
    }
  });

  AxiosAPI.post(`/api/tasks/${id.value}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${Store.accessToken}`
    }
  }).then(() => {
    EditNameTask.value = '';
    EditDescriptionTask.value = '';
    Edithour.value = '';
    EditPlace.value = '';
    EditPlaceLink.value = '';
    EditPriority.value = '';
    attachments.value = [];
    EditTack.value = [];

    if (emitter) {
      emitter.emit('KanbanUpdated');
    }
    if (viewDocument.value) {
      viewDocument.value.closeModal();
    }
  }).catch(error => {
    console.error('Erro ao editar tarefa:', error);
  });
};

const printPdf = (value, despacho) => {
  const printPdfWindow = window.open(Store.host + despacho.file_path, '', 'width=800,height=600');
  if (printPdfWindow) {
    printPdfWindow.onload = () => {
      printPdfWindow.print();
    };
  }
};

defineExpose({
  openTask
});
</script>

<style scoped>
.dropdown-content p {
  margin: 0;
  padding: 8px;
  cursor: pointer;
}
.dropdown-content p:hover {
  background-color: #f0f0f0;
}
</style>

<template>
  <div>
    <ModalCopy ref="ModalCopyRef" />
    <ModalDelete ref="ModalDeleteRef" />
    <ModalResponsable ref="modalResponsable"/>
    <ModalMain ref="viewDocument">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span class="font-docs text-black" style="font-size: 20px"><strong>Atividade</strong></span>
          </div>

          <div class="d-flex align-items-center">
            <i v-if="!editCard && Store.EditresponsableTask?.id === Store.user?.id" class="fa-solid fa-pen Color-Docs mr-3" style="font-size: 20px; cursor:pointer" @click="editCardModel"></i>
            <i v-if="!editCard && Store.EditresponsableTask?.id === Store.user?.id" class="fa-solid fa-trash Color-Docs mr-3" style="font-size: 20px; cursor:pointer" @click="RemoveCard"></i>
            <i v-if="!editCard && Store.EditresponsableTask?.id === Store.user?.id" class="fa-solid fa-copy Color-Docs mr-3" style="font-size: 20px; cursor:pointer" @click="CopyCard"></i>
            <button
              id="close"
              type="button"
              class="close"
              @click="viewDocument.closeModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <template #body>
        <div :class="Store.mobile ? '' : 'd-flex'">
          <div :class="Store.mobile ? 'w-100 mt-3 d-flex align-items-center' : 'w-20 mt-3'">
            <div :class="Store.mobile ? 'mr-2' : ''" class="d-flex align-items-center" style="cursor:pointer" @click="viewSelect = 'Resume'">
              <i class="fa-solid fa-newspaper mr-2"></i>
              <span class="font-docs">Resumo</span>
            </div>

            <div :class="Store.mobile ? 'mr-2' : 'mt-3'" class="d-flex align-items-center" style="cursor:pointer" @click="viewSelect = 'Files'">
              <i class="fa-brands fa-gg mr-2"></i>
              <span class="font-docs">Arquivos</span>
            </div>

            <div :class="Store.mobile ? 'mr-2' : 'mt-3'" class="d-flex align-items-center" style="cursor:pointer" @click="viewSelect = 'Convidados'">
              <i class="fa-solid fa-users mr-2"></i>
              <span class="font-docs">Convidados</span>
            </div>

            <div :class="Store.mobile ? 'mr-2' : 'mt-3'" class="d-flex align-items-center" style="cursor:pointer" @click="viewSelect = 'timeline'">
              <i class="fa-regular fa-clock mr-2"></i>
              <span class="font-docs">Histórico</span>
            </div>
          </div>

          <div :class="Store.mobile ? 'w-100' : 'w-75'" v-if="viewSelect === 'Resume'">
            <div v-if="!editCard" class="mt-3">
              <span class="font-docs"> <b>{{ TaskName }}</b></span>
            </div>

            <div v-if="editCard" class="mt-3">
              <label class="label-docs">Nome <span style="color:red">*</span></label>
              <input type="text" class="my_form" v-model="EditNameTask" placeholder="Nome da tarefa" />
            </div>

            <div v-if="!editCard" class="d-flex justify-content-between align-items-center mt-3">
              <div class="d-flex">
                <i class="fa-regular fa-calendar-check mr-2" style="font-size: 20px;color:#6C757D"></i>
                <div class="d-grid">
                  <span class="font-docs"><b>Data e hora</b></span>
                  <span class="font-docs" style="color:#6C757D"> {{ formatDate(formatedDates) }} - {{ formatHour(hour) }}</span>
                </div>
              </div>

              <div class="d-grid">
                <span class="font-docs"><b>Situação</b></span>
                <Tag v-if="situation === '1'" rounded style='background-color: #E9ECEF;color:#6C757D;'>
                  <div class='flex align-items-center gap-2'>
                    <span class='text-base font-docs'><b>À iniciar</b></span>
                  </div>
                </Tag>
                <Tag v-if="situation === '2'" rounded style='background-color: #CFF4FC;color: #087990;'>
                  <div class='flex align-items-center gap-2'>
                    <span class='text-base font-docs'><b>Em andamento</b></span>
                  </div>
                </Tag>
                <Tag v-if="situation === '4'" rounded style='background-color: #F8D7DA;color: #842029;'>
                  <div class='flex align-items-center gap-2'>
                    <span class='text-base font-docs'><b>Bloqueado</b></span>
                  </div>
                </Tag>
                <Tag v-if="situation === '3'" rounded style='background-color: rgba(9,167, 6, 0.1);color: rgb(9 167 6);'>
                  <div class='flex align-items-center gap-2'>
                    <span class='text-base font-docs'><b>Concluída</b></span>
                  </div>
                </Tag>
              </div>

              <div class="d-grid">
                <span class="font-docs"><b>Prioridade</b></span>
                <div v-if="priority === '1'" class="d-flex">
                  <i class="fa-solid fa-angle-up mr-1" style="color:#0D6EFD;position: relative; top: 5px;"></i>
                  <span>Baixa</span>
                </div>

                <div v-if="priority === '2'" class="d-flex">
                  <div class="d-grid mr-1">
                    <i class="fa-solid fa-angle-up" style="color:#FFC107;"></i>
                    <i class="fa-solid fa-angle-up" style="color:#FFC107;position: relative;bottom: 10px;"></i>
                  </div>
                  <span>Média</span>
                </div>

                <div v-if="priority === '3'" class="d-flex">
                  <div class="d-grid mr-1">
                    <i class="fa-solid fa-angle-up" style="color:#F76659;"></i>
                    <i class="fa-solid fa-angle-up" style="color:#F76659; position: relative;bottom: 10px;"></i>
                    <i class="fa-solid fa-angle-up" style="color:#F76659; position: relative;bottom: 20px;"></i>
                  </div>
                  <span>Alta</span>
                </div>
              </div>
            </div>

            <div v-if="editCard">
              <div class="row">
                <div class="col">
                  <label class="label-docs mt-3">Data <span style="color:red">*</span></label>
                  <input type="date" class="my_form" v-model="editDate" />
                </div>
                <div class="col">
                  <label class="label-docs mt-3">Horario</label>
                  <input type="time" class="my_form" v-model="Edithour" />
                </div>
                <div class="col">
                  <label class="label-docs mt-3">Situação <span style="color:red">*</span></label>
                  <Dropdown
                    v-model="EditSituation"
                    :options="situationChose"
                    optionLabel="label"
                    placeholder="Selecione um status"
                    class="w-100"
                  >
                    <template #value="slotProps">
                      <div class="flex align-items-center">
                        <Tag v-if="slotProps.value === '1' || slotProps.value?.value === '1'" rounded style='background-color: #E9ECEF;color:#6C757D;padding: 0rem 0.75rem !important;'>
                          <span class='text-base font-docs'><b>À iniciar</b></span>
                        </Tag>
                        <Tag v-if="slotProps.value === '2' || slotProps.value?.value === '2'" rounded style='background-color: #CFF4FC;color: #087990;padding: 0rem 0.75rem !important;'>
                          <span class='text-base font-docs'><b>Em andamento</b></span>
                        </Tag>
                        <Tag v-if="slotProps.value === '4' || slotProps.value?.value === '4'" rounded style='background-color: #F8D7DA;color: #842029;padding: 0rem 0.75rem !important;'>
                          <span class='text-base font-docs'><b>Bloqueado</b></span>
                        </Tag>
                        <Tag v-if="slotProps.value === '3' || slotProps.value?.value === '3'" rounded style='background-color: rgba(9,167, 6, 0.1);color: rgb(9 167 6);padding: 0rem 0.75rem !important;'>
                          <span class='text-base font-docs'><b>Concluída</b></span>
                        </Tag>
                      </div>
                    </template>
                    <template #option="{ option }">
                      <Tag v-if="option.label === 'À iniciar'" rounded style='background-color: #E9ECEF;color:#6C757D;'>
                        <span class='text-base font-docs'><b>{{ option.label }}</b></span>
                      </Tag>
                      <Tag v-if="option.label === 'Em andamento'" rounded style='background-color: #CFF4FC;color: #087990;'>
                        <span class='text-base font-docs'><b>{{ option.label }}</b></span>
                      </Tag>
                      <Tag v-if="option.label === 'Bloqueado'" rounded style='background-color: #F8D7DA;color: #842029;'>
                        <span class='text-base font-docs'><b>{{ option.label }}</b></span>
                      </Tag>
                      <Tag v-if="option.label === 'Concluída'" rounded style='background-color: rgba(9,167, 6, 0.1);color: rgb(9 167 6);'>
                        <span class='text-base font-docs'><b>{{ option.label }}</b></span>
                      </Tag>
                    </template>
                  </Dropdown>
                </div>
                <div class="col">
                  <label class="label-docs mt-3">Prioridade</label>
                  <Dropdown
                    v-model="EditPriority"
                    :options="priorityLabels"
                    optionLabel="label"
                    placeholder="Selecione um status"
                    class="w-100"
                  >
                    <template #value="slotProps">
                      <div class="flex align-items-center">
                        <div v-if="slotProps.value === '1' || slotProps.value?.value === 1" class="d-flex">
                          <i class="fa-solid fa-angle-up mr-1" style="color:#0D6EFD;position: relative; top: 5px;"></i>
                          <span>Baixa</span>
                        </div>
                        <div v-if="slotProps.value === '2' || slotProps.value?.value === 2" class="d-flex">
                          <div class="d-grid mr-1">
                            <i class="fa-solid fa-angle-up" style="color:#FFC107;"></i>
                          </div>
                          <span>Média</span>
                        </div>
                        <div v-if="slotProps.value === '3' || slotProps.value?.value === 3" class="d-flex">
                          <div class="d-grid mr-1">
                            <i class="fa-solid fa-angle-up" style="color:#F76659;"></i>
                          </div>
                          <span>Alta</span>
                        </div>
                      </div>
                    </template>
                    <template #option="{ option }">
                      <div v-if="option.label === 'Baixa'" class="d-flex">
                        <i class="fa-solid fa-angle-up mr-1" style="color:#0D6EFD;position: relative; top: 5px;"></i>
                        <span>{{ option.label }}</span>
                      </div>
                      <div v-if="option.label === 'Média'" class="d-flex">
                        <i class="fa-solid fa-angle-up mr-1" style="color:#FFC107;position: relative; top: 5px;"></i>
                        <span>{{ option.label }}</span>
                      </div>
                      <div v-if="option.label === 'Alta'" class="d-flex">
                        <i class="fa-solid fa-angle-up mr-1" style="color:#F76659;position: relative; top: 5px;"></i>
                        <span>{{ option.label }}</span>
                      </div>
                    </template>
                  </Dropdown>
                </div>
              </div>
            </div>

            <div v-if="!editCard" class="d-flex mt-3">
              <div class="d-flex">
                <i class="fa-solid fa-bars-staggered mr-2" aria-hidden="true" style="font-size:20px;color:#6C757D"></i>
                <div class="d-grid">
                  <span class="font-docs"><b>Descrição</b></span>
                  <span class="font-docs" style="color:#6C757D">{{ description }}</span>
                </div>
              </div>
            </div>

            <div v-if="editCard" class="mt-3">
              <label class="label-docs mt-1">Descrição</label>
              <textarea name="Description" id="Description" v-model="EditDescriptionTask" class="my_form" style="height: 86px;"></textarea>
            </div>

            <div v-if="!editCard" class="d-flex mt-3">
              <div class="d-flex">
                <i class="fa-solid fa-location-dot mr-2" style="font-size:20px;color:#6C757D"></i>
                <div class="d-grid">
                  <span class="font-docs"><b>Local</b></span>
                  <span v-if="location" class="font-docs" style="color:#6C757D">{{ location }}</span>
                  <span v-if="!location" class="font-docs" style="color:#6C757D">Não informado</span>
                  <a class="font-docs" :href="access_link" style="color:#6C757D">{{ access_link }}</a>
                </div>
              </div>
            </div>

            <div v-if="editCard" class="row">
              <div class="col">
                <label class="label-docs mt-3">Local</label>
                <input type="text" v-model="EditPlace" class="my_form" placeholder="Meet" />
              </div>
              <div class="col">
                <label class="label-docs mt-3">Link de acesso à videoconferência</label>
                <input type="text" v-model="EditPlaceLink" class="my_form" placeholder="https://meet.google.com/"/>
              </div>
            </div>

            <div class="d-grid mt-3">
              <span class="font-docs mt-3">Responsável</span>
              <div v-if="!editCard" class="d-flex align-items-center mt-1">
                <img
                  :src="$userAvatar(responsible?.path_image)"
                  alt="Avatar"
                  class="mr-2"
                  style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;">
                <div class="d-grid">
                  <span class="font-docs"><b>{{ responsible?.name }}</b></span>
                  <span class="font-docs" style="font-size: 14px">{{ responsible?.email }}</span>
                </div>
              </div>

              <div v-if="editCard" class="d-flex align-items-center mt-1">
                <img
                  :src="$userAvatar(Store.EditresponsableTask?.path_image)"
                  alt="Avatar"
                  class="mr-2"
                  style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;">
                <div class="d-grid">
                  <span class="font-docs"><b>{{ Store.EditresponsableTask?.name }}</b></span>
                  <span class="font-docs" style="font-size: 14px">{{ Store.EditresponsableTask?.email }}</span>
                </div>
                <i class="fa-solid fa-pen Color-Docs ml-2" style="font-size: 25px; cursor:pointer" @click="editResponsable"></i>
              </div>
            </div>

            <div v-if="CheckList">
              <TodoListUpdated ref="TodoListUpdatedRef" :ExistCheckList="CheckList" :TaskID="id"/>
            </div>
          </div>

          <div class="w-75" v-if="viewSelect === 'Files'">
            <div v-if="attachments.length >= 1 && !editCard" class='mt-3 mb-4'>
              <div class='mt-3'>
                <span v-for='(attachment, index) in attachments' :key='index' class='d-flex ml-2 Color-Docs' style='height: 40px;align-items: center;'>
                  <i class="fa fa-file-o mr-2" aria-hidden="true"></i>
                  {{attachment.name}}
                  <div class="d-flex ml-2" style="cursor:pointer" @click="printPdf(3, attachment)">
                    <font-awesome-icon :icon="['fas', 'download']" />
                  </div>
                </span>
              </div>
            </div>
            <div v-if="attachments.length <= 0 && !editCard" class='mt-3'>
              <span class="font-docs" style="color:#6C757D">Nenhum anexo nessa atividade</span>
            </div>

            <div v-if="editCard">
              <button class="btn Color-Docs mt-5" style="border: 1px solid #F1860B" @click='openFileInput'>
                <i class="fa-solid fa-arrow-up-from-bracket mr-2"></i>
                <input type='file' ref='fileInput' @change='addAttachment' accept='.doc,.docx,.odt,.pdf,.png,.jpg,.svg' style='display: none' multiple/>
                Adicionar arquivo
              </button>

              <div class='mt-2 mb-4'>
                <div class='mt-3'>
                  <span v-for='(attachment, index) in attachments' :key='index' class='d-flex ml-2 Color-Docs' style='height: 40px;align-items: center;'>
                    <i class="fa fa-file-o mr-2" aria-hidden="true"></i>
                    {{attachment.name}}
                    <button type='button' @click='removeAttachment(index)' style='border: none;'>
                      <i class="fa fa-trash-o ml-2" aria-hidden="true" style="color: #212529"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="w-75" v-if="viewSelect === 'Convidados'">
            <div class="mt-3">
              <span class="font-docs"><b>Convidados</b></span>
            </div>

            <div v-if="!editCard">
              <div class="mt-2" v-for="user in users" :key="user.id || user">
                <div class="d-flex align-items-center">
                  <img
                    :src="$userAvatar(user?.path_image)"
                    alt="Avatar"
                    class="mr-2"
                    style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;">
                  <div class="d-grid">
                    <span class="font-docs"><b>{{ user.name }}</b></span>
                    <span class="font-docs" style="font-size: 14px">{{ user.email }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="editCard">
              <MultiSelectPrime
                display="chip"
                v-model="Editusers"
                :options="Store.users"
                filter optionLabel="name"
                placeholder="Selecione os envolvidos na tarefa"
                :maxSelectedLabels="3"
                style="z-index: 9999 !important; height: calc(3.475rem + 2px);"
                class="w-full my_form">
                <template #option="slotProps">
                  <div class="d-flex align-items-center">
                    <img :alt="slotProps.option.name" :src="$userAvatar(slotProps.option.path_image)" class="mr-2" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover;" />
                    <div>{{ slotProps.option.name }}</div>
                  </div>
                </template>
                <template #footer>
                  <div class="py-2 px-3">
                    <b>{{ Editusers ? Editusers.length : 0 }}</b> usuário(s) selecionado(s).
                  </div>
                </template>
              </MultiSelectPrime>
            </div>
          </div>

          <div class="w-75" v-if="viewSelect === 'timeline'">
            <div class="mt-3">
              <span class="font-docs"><b>Histórico de atividade</b></span>
            </div>

            <div>
              <Timeline :value="logsAll">
                <template #opposite="slotProps">
                  <div class="d-grid">
                    <span class="font-docs" style="color:#465668">{{ formatDate(slotProps.item.created_at) }}</span>
                  </div>
                </template>
                <template #content="slotProps">
                  <span class="font-docs-recived-header" style="color:#465668">{{ slotProps.item.user?.name }}</span>
                  <div>
                    <span class="font-docs" style="color:#465668">{{ slotProps.item.message }}</span>
                  </div>
                </template>
              </Timeline>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div v-if="editCard" class="d-flex justify-content-end mt-4">
          <button class="btn Color-Docs font-docs mr-3" style="border: 1px solid #F1860B" @click="editCard = false">
            Cancelar
          </button>
          <button class="btn background-Docs text-white font-docs" @click="EditTask">
            Salvar
          </button>
        </div>
      </template>
    </ModalMain>
  </div>
</template>